import { z } from 'zod';
export var Commission = z.union([z.object({
  commissionRate: z.number(),
  type: z.literal('flat'),
  currency: z.string().nullish(),
  estimatedCommission: z.object({
    value: z.number(),
    currency: z.string(),
    disclaimer: z.string().nullish()
  }).nullish()
}), z.object({
  commissionRate: z.number(),
  type: z.literal('percent').nullish().transform(function (item) {
    return item || 'percent';
  }),
  estimatedCommission: z.object({
    value: z.number(),
    currency: z.string(),
    disclaimer: z.string().nullish()
  }).nullish()
})]);
export var CommissionResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_commission'),
  currency: z.string().nullish()
});
export var CommissionHistoryResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_commission_history'),
  id: z.string()
});
export var CommissionHistoryItem = z.union([z.object({
  id: z.string(),
  commissionRate: z.number(),
  type: z.literal('flat'),
  currency: z.string().nullish(),
  comment: z.string().nullish(),
  createdAt: z.string()
}), z.object({
  id: z.string(),
  commissionRate: z.number(),
  type: z.literal('percent').nullish().transform(function (item) {
    return item || 'percent';
  }),
  comment: z.string().nullish(),
  createdAt: z.string()
})]);
export var CommissionStatusResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('commission_status')
});
var CommissionInstallment = z.object({
  installmentNumber: z.number().nullish(),
  status: z.string().nullish(),
  semesterStartDate: z.string().nullish(),
  semesterType: z.string().nullish(),
  firstInquiryDate: z.string().nullish(),
  lastInquiryDate: z.string().nullish(),
  eta: z.string().nullish()
});
export var CommissionStatus = z.object({
  commissionEligible: z.string().nullish(),
  eligibilityLabel: z.string().nullish(),
  installments: z.array(CommissionInstallment).nullish()
});
export var CommissionTransaction = z.object({
  currency: z.string(),
  currencySymbol: z.string(),
  dateOfTransaction: z.string(),
  total: z.number(),
  transactionNote: z.string().nullish()
});
export var CommissionTransactionResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_transaction')
});
export var AdvancedCommissionTransactionResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('application_advanced_transaction')
});

/** TODO: Remove this once https://applyboard.atlassian.net/browse/APA-1963 is done
 *  Please do not use this schema.
 *  We are temporarily defaulting to the application's school currency for flat
 *  amount commissions due to a bug where `currency` is frequently null.
 */
export var CommissionSchoolResponse = z.object({
  attributes: z.object({}).passthrough(),
  type: z.literal('school')
});

/** TODO: Remove this once https://applyboard.atlassian.net/browse/APA-1963 is done
 *  Please do not use this schema.
 *  We are temporarily defaulting to the application's school currency for flat
 *  amount commissions due to a bug where `currency` is frequently null.
 */
export var CommissionSchool = z.object({
  currency: z.string()
});